import { render, staticRenderFns } from "./industry.vue?vue&type=template&id=52d5eb25&"
import script from "./industry.vue?vue&type=script&lang=js&"
export * from "./industry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports